import React, { useEffect, useState } from "react";
import { Alert, Col, Form, Row, Spinner, Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  editCompetencieXCompetencieType,
  getCompetencies,
  getCompetenciesXCompetencieType,
} from "../../redux/descriptorsProfiles/competencies/actions";
import CompetenceRange from "./CompetenceRange";

const CompetenceLevel = (props) => {
  const [loader, setLoader] = useState(false);
  const [firstLoad, setFirstLoad] = useState(false);
  const [_numCompetencias, setNumCompetencias] = useState(null);
  const [competenciaTemp, setcompetenciaTemp] = useState([]);
  const [competenciaTempCount, setcompetenciaTempCount] = useState(0);
  const [competenciaTempError, setcompetenciaTempError] = useState("");

  const dispatch = useDispatch();

  // const { competencies } = useSelector(
  //   (store) => store.competencies
  // );

  useEffect(() => {
    dispatch(
      getCompetenciesXCompetencieType(
        {
          tipo_busqueda: "tipo_competencia_id",
          filter: props.competenceType.id,
          segundo_tipo_busqueda: "descriptor_id",
          segundo_filter: props.idDescriptor,
        },
        setLoader,
        setcompetenciaTemp,
        setcompetenciaTempCount,
        setNumCompetencias,
        setcompetenciaTempError,
        setFirstLoad
      )
    );
  }, []);

  useEffect(() => {
    if (competenciaTempCount > 0 && _numCompetencias !== null && firstLoad) {
      let _numTemp = 0;
      if (props.competenceType.competencia_indispensable) {
        _numTemp = _numTemp + parseInt(props.competenceType.numero_competencia);
      } else {
        _numTemp = _numTemp + parseInt(_numCompetencias);
      }
      props.setTotal(parseInt(props.total) - parseInt(_numTemp));
      setFirstLoad(false);
    }
  }, [competenciaTempCount, _numCompetencias, firstLoad]);

  return (
    <div>
      {loader ? (
        <>
          <div className="d-flex justify-content-center">
            <Spinner
              animation="border"
              role="status"
              className="d-flex justify-content-center"
            />
          </div>
        </>
      ) : (
        <>
          {competenciaTempCount !== 0 && (
            <>
              {props.competenceType.competencia_indispensable &&
                parseInt(_numCompetencias) >= 0 &&
                parseInt(props.competenceType.numero_competencia) -
                  parseInt(_numCompetencias) >
                  0 && (
                  <div className="border-left border-warning">
                    <Alert className="mb-0" variant="light">
                      Debe seleccionar{" "}
                      {parseInt(_numCompetencias) >= 0
                        ? `${
                            parseInt(props.competenceType.numero_competencia) -
                            parseInt(_numCompetencias)
                          } competencia${
                            parseInt(props.competenceType.numero_competencia) -
                              parseInt(_numCompetencias) ===
                            1
                              ? " "
                              : "s "
                          }`
                        : `${parseInt(
                            props.competenceType.numero_competencia
                          )} competencia${
                            parseInt(
                              props.competenceType.numero_competencia
                            ) === 1
                              ? " "
                              : "s "
                          }`}
                      mas.
                    </Alert>
                  </div>
                )}
              {!props.competenceType.competencia_indispensable &&
                parseInt(_numCompetencias) >= 0 &&
                parseInt(props.competenceType.numero_competencia) -
                  parseInt(_numCompetencias) >
                  0 &&
                parseInt(props.total) >=
                  parseInt(props.competenceType.numero_competencia) -
                    parseInt(_numCompetencias) && (
                  <div className="border-left border-warning">
                    <Alert className="mb-0" variant="light">
                      Seleccione{" "}
                      {parseInt(_numCompetencias) >= 0
                        ? `${
                            parseInt(props.competenceType.numero_competencia) -
                            parseInt(_numCompetencias)
                          } competencia${
                            parseInt(props.competenceType.numero_competencia) -
                              parseInt(_numCompetencias) ===
                            1
                              ? " "
                              : "s "
                          }`
                        : `${parseInt(
                            props.competenceType.numero_competencia
                          )} competencia${
                            parseInt(
                              props.competenceType.numero_competencia
                            ) === 1
                              ? " "
                              : "s "
                          }`}
                      mas.
                    </Alert>
                  </div>
                )}
              {!props.competenceType.competencia_indispensable &&
                parseInt(props.total) > 0 &&
                parseInt(props.competenceType.numero_competencia) -
                  parseInt(_numCompetencias) >
                  0 &&
                parseInt(props.total) <
                  parseInt(props.competenceType.numero_competencia) -
                    parseInt(_numCompetencias) && (
                  <div className="border-left border-warning">
                    <Alert className="mb-0" variant="light">
                      Seleccione {parseInt(props.total)} competencia
                      {parseInt(props.total) === 1 ? "" : "s"} mas.
                    </Alert>
                  </div>
                )}
              <Table borderless>
                <tbody>
                  <tr className="my-0">
                    <td className="my-0">
                      <Col>
                        <Row className="d-flex flex-wrap justify-content-center align-items-center">
                          <h6 className="border-bottom border-warning">
                            Competencias
                          </h6>
                        </Row>
                      </Col>
                    </td>
                    <td>
                      <Col>
                        <Row className="d-flex flex-wrap justify-content-center align-items-center">
                          <h6 className="border-bottom border-warning">
                            Nivel de Desarrollo
                          </h6>
                        </Row>
                      </Col>
                    </td>
                    <td></td>
                  </tr>
                  {competenciaTemp.map((item, index) => (
                    <tr className="my-0">
                      <td className="my-0">
                        {/* <Col md="5" className="mx-auto"> */}
                        <li className="mx-auto" style={{ width: "45%" }}>
                          {item.list_competencia[0].nombre}
                        </li>
                        {/* </Col> */}
                      </td>
                      <td>
                        <CompetenceRange
                          numCompetencias={
                            props.competenceType.numero_competencia
                          }
                          _numCompetencias={_numCompetencias}
                          setNumCompetencias={setNumCompetencias}
                          item={item}
                          total={props.total}
                          setTotal={props.setTotal}
                          competenceType={props.competenceType}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </>
          )}
        </>
      )}
      {!loader && competenciaTempCount === 0 && competenciaTempError === "" && (
        <Alert variant="info">
          Aún no hay competencias para este tipos de competencia, comuniquese
          con el administrador para mas información.
        </Alert>
      )}
      {!!competenciaTempError && (
        <Alert variant="danger">{competenciaTempError}</Alert>
      )}
    </div>
  );
};

export default CompetenceLevel;
